/* src/lib/components/Card/TechCard.ts */

import Card from "@root/components/cards/card/card";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class TechCard extends Card {
    /**
     * 是否移除 Body 的內邊距 (Padding)
     * 用途：當卡片內容是滿版表格 (Table) 時設為 true
     */
    @Prop({ type: Boolean, default: true })
    noBodyPadding!: boolean;

    /**
     * 判斷是否顯示 Header
     * 邏輯：如果有傳入 label (prop 或 slot) 或有 toolbox slot 才顯示
     */
    get showHeader(): boolean {
        // label 來自 BaseComponent 或 Card 定義的 prop
        // publicSlots 來自 Card 定義
        return !!(this.label || this.$slots[this.publicSlots.label] || this.$slots[this.publicSlots.toolbox]);
    }
}